import { setPermisos } from 'store/catalogos';
import API from 'utils/api';
import { onError } from 'utils/handlers';

const baseURL = '/usuarios';

/**
 * GET Generos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getGeneros = async (params) => {
  try {
    const response = await API.get(`${baseURL}/generos/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Estados Civiles
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getEstadosCiviles = async (params) => {
  try {
    const response = await API.get(`${baseURL}/estados-civiles/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Permisos
 * @returns {Promise<object[]>}
 */
export const getPermisos = async (dispatch, permisos = []) => {
  try {
    if (permisos.length) {
      return permisos;
    }
    const response = await API.get(`${baseURL}/permisos/`);
    dispatch(setPermisos(response.data));
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
